export default "__VITE_ASSET__B3kJIg7k__"